import { BRAND } from "../risikoanalyseStep/tokens";
import type { ContractStepKind } from "./types";

const W = 140;
const H = 96;

const Wrap = ({ children }: { children: React.ReactNode }) => (
  <svg width={W} height={H} viewBox="0 0 140 96" fill="none">
    {children}
  </svg>
);

const Allgemein = () => (
  <Wrap>
    <rect x="14" y="20" width="56" height="58" rx="3" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M22 32h40M22 42h32M22 52h36M22 62h22" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <rect x="78" y="32" width="46" height="46" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" />
    <rect x="84" y="40" width="8" height="10" fill={BRAND.bg} />
    <rect x="96" y="40" width="8" height="10" fill={BRAND.bg} />
    <rect x="108" y="40" width="8" height="10" fill={BRAND.bg} />
    <rect x="84" y="56" width="34" height="22" fill={BRAND.bg} />
  </Wrap>
);

const Eigentuemer = () => (
  <Wrap>
    <circle cx="40" cy="44" r="14" fill={BRAND.purple} />
    <path d="M22 80c0-10 8-18 18-18s18 8 18 18" fill={BRAND.purple} />
    <circle cx="92" cy="48" r="10" fill={BRAND.gold} />
    <path d="M78 80c0-7 6-14 14-14s14 7 14 14" fill={BRAND.gold} />
    <path d="M58 56l16 0" stroke={BRAND.gold} strokeWidth="2" strokeDasharray="3 3" />
  </Wrap>
);

const Zahlung = () => (
  <Wrap>
    <rect x="14" y="32" width="84" height="40" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="14" y="38" width="84" height="8" fill={BRAND.purple} />
    <circle cx="32" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="50" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="68" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="86" cy="58" r="4" fill={BRAND.gold} />
    <circle cx="116" cy="48" r="14" fill={BRAND.gold} />
    <text x="116" y="54" fontFamily="Arial" fontSize="14" textAnchor="middle" fill={BRAND.ink} fontWeight="700">€</text>
  </Wrap>
);

const Versicherungssumme = () => (
  <Wrap>
    <rect x="14" y="28" width="112" height="44" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <text x="42" y="58" fontFamily="Arial" fontSize="22" textAnchor="middle" fill={BRAND.purple} fontWeight="700">€</text>
    <path d="M70 38v24M62 50h16" stroke={BRAND.gold} strokeWidth="3" strokeLinecap="round" />
    <text x="106" y="58" fontFamily="Arial" fontSize="14" textAnchor="middle" fill={BRAND.ink} fontWeight="700">100%</text>
  </Wrap>
);

const Uvv = () => (
  <Wrap>
    <path d="M70 14l32 12v22c0 18-14 32-32 38-18-6-32-20-32-38V26l32-12z" fill={BRAND.gold} />
    <text x="70" y="58" fontFamily="Arial" fontSize="20" textAnchor="middle" fill={BRAND.ink} fontWeight="700">UVV</text>
  </Wrap>
);

const GefahrenMietverlust = () => (
  <Wrap>
    <rect x="14" y="20" width="112" height="60" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <line x1="14" y1="32" x2="126" y2="32" stroke={BRAND.purple} strokeWidth="1.5" />
    <line x1="60" y1="20" x2="60" y2="80" stroke={BRAND.purple} strokeOpacity="0.4" strokeWidth="0.8" />
    <line x1="90" y1="20" x2="90" y2="80" stroke={BRAND.purple} strokeOpacity="0.4" strokeWidth="0.8" />
    <rect x="62" y="40" width="24" height="6" fill={BRAND.gold} />
    <rect x="92" y="40" width="20" height="6" fill={BRAND.gold} opacity="0.7" />
    <rect x="62" y="52" width="24" height="6" fill={BRAND.gold} opacity="0.6" />
    <rect x="92" y="52" width="14" height="6" fill={BRAND.gold} opacity="0.6" />
    <rect x="62" y="64" width="24" height="6" fill={BRAND.gold} opacity="0.4" />
    <circle cx="32" cy="50" r="10" fill={BRAND.gold} />
    <text x="32" y="55" fontFamily="Arial" fontSize="14" textAnchor="middle" fill={BRAND.ink} fontWeight="700">!</text>
  </Wrap>
);

const BeitragAntrag = () => (
  <Wrap>
    <circle cx="44" cy="48" r="24" fill={BRAND.gold} />
    <text x="44" y="56" fontFamily="Arial" fontSize="26" textAnchor="middle" fill={BRAND.ink} fontWeight="700">€</text>
    <rect x="76" y="22" width="48" height="56" rx="3" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M82 32h36M82 42h36M82 52h28M82 62h22" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="118" cy="68" r="8" fill={BRAND.gold} />
    <path d="M114 68 l3 3 l5 -6" stroke={BRAND.ink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const Bedingungen = () => (
  <Wrap>
    <rect x="20" y="14" width="100" height="68" rx="3" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M28 28h84M28 38h84M28 48h84M28 58h64M28 68h74" stroke={BRAND.muted} strokeWidth="1.4" strokeLinecap="round" />
  </Wrap>
);

const Photovoltaik = () => (
  <Wrap>
    <rect x="20" y="50" width="100" height="22" fill={BRAND.purple} stroke={BRAND.ink} strokeWidth="1.5" />
    <path d="M20 50h100l8-12H28z" fill={BRAND.purple} stroke={BRAND.ink} strokeWidth="1.5" />
    <line x1="44" y1="50" x2="48" y2="38" stroke={BRAND.gold} strokeWidth="1" />
    <line x1="68" y1="50" x2="72" y2="38" stroke={BRAND.gold} strokeWidth="1" />
    <line x1="92" y1="50" x2="96" y2="38" stroke={BRAND.gold} strokeWidth="1" />
    <line x1="20" y1="60" x2="120" y2="60" stroke={BRAND.gold} strokeWidth="1" />
    <circle cx="100" cy="22" r="10" fill={BRAND.gold} />
    <path d="M100 8v6M100 30v6M86 22h6M108 22h6M90 12l4 4M110 32l-4-4M90 32l4-4M110 12l-4 4" stroke={BRAND.gold} strokeWidth="1.5" strokeLinecap="round" />
  </Wrap>
);

const Differenzdeckung = () => (
  <Wrap>
    <rect x="14" y="20" width="56" height="56" rx="4" fill={BRAND.purple} />
    <rect x="70" y="20" width="56" height="56" rx="4" fill={BRAND.gold} />
    <line x1="70" y1="20" x2="70" y2="76" stroke={BRAND.ink} strokeWidth="2" strokeDasharray="3 3" />
    <text x="42" y="54" fontFamily="Arial" fontSize="20" textAnchor="middle" fill={BRAND.gold} fontWeight="700">A</text>
    <text x="98" y="54" fontFamily="Arial" fontSize="20" textAnchor="middle" fill={BRAND.ink} fontWeight="700">B</text>
  </Wrap>
);

const Bemerkungen = () => (
  <Wrap>
    <rect x="20" y="20" width="100" height="52" rx="6" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M30 30h60M30 40h60M30 50h40" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M40 72l10 10 10-10z" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
  </Wrap>
);

const BesondereHinweise = () => (
  <Wrap>
    <circle cx="70" cy="48" r="32" fill={BRAND.gold} />
    <text x="70" y="58" fontFamily="Arial" fontSize="40" textAnchor="middle" fill={BRAND.ink} fontWeight="700">!</text>
  </Wrap>
);

const Summary = () => (
  <Wrap>
    <rect x="20" y="14" width="100" height="68" rx="6" fill={BRAND.white} stroke={BRAND.purple} strokeWidth="2" />
    <line x1="34" y1="32" x2="86" y2="32" stroke={BRAND.muted} strokeWidth="2" strokeLinecap="round" />
    <line x1="34" y1="46" x2="100" y2="46" stroke={BRAND.muted} strokeWidth="2" strokeLinecap="round" />
    <line x1="34" y1="60" x2="76" y2="60" stroke={BRAND.muted} strokeWidth="2" strokeLinecap="round" />
    <circle cx="106" cy="68" r="14" fill={BRAND.gold} />
    <path d="M99 68 l5 5 l8 -10" stroke={BRAND.ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const HEROES: Partial<Record<ContractStepKind, () => JSX.Element>> = {
  kontakt: Allgemein,
  vertragsBasis: Allgemein,
  vereinbarung: Bedingungen,
  versicherungssumme: Versicherungssumme,
  uvv: Uvv,
  gefahren: GefahrenMietverlust,
  gefahrenVergleich: Differenzdeckung,
  photovoltaik: Photovoltaik,
  vertragsdatenZahlung: Zahlung,
  bedingungenDokumente: Bedingungen,
  bemerkungenHinweise: Bemerkungen,
  summary: Summary,
};

const StepHero = ({ kind }: { kind: ContractStepKind }) => {
  const Hero = HEROES[kind];
  return Hero ? <Hero /> : null;
};

export default StepHero;
